import _regeneratorRuntime from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { utf8ToBytes } from '@stacks/common';
export var FileContentLoader =
/*#__PURE__*/
function () {
  function FileContentLoader(content, contentType) {
    _classCallCheck(this, FileContentLoader);

    this.wasString = typeof content === 'string';
    this.content = FileContentLoader.normalizeContentDataType(content, contentType);
    this.contentType = contentType || this.detectContentType();
    this.contentByteLength = this.detectContentLength();
  }

  _createClass(FileContentLoader, [{
    key: "detectContentType",
    value: function detectContentType() {
      if (this.wasString) {
        return 'text/plain; charset=utf-8';
      } else if (typeof Blob !== 'undefined' && this.content instanceof Blob && this.content.type) {
        return this.content.type;
      } else {
        return 'application/octet-stream';
      }
    }
  }, {
    key: "detectContentLength",
    value: function detectContentLength() {
      if (ArrayBuffer.isView(this.content) || this.content instanceof Uint8Array) {
        return this.content.byteLength;
      } else if (typeof Blob !== 'undefined' && this.content instanceof Blob) {
        return this.content.size;
      }

      var typeName = Object.prototype.toString.call(this.content);
      var error = new Error("Unexpected type \"".concat(typeName, "\" while detecting content length"));
      console.error(error);
      throw error;
    }
  }, {
    key: "loadContent",
    value: function () {
      var _loadContent = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var reader, readPromise, typeName, loadContentError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(this.content instanceof Uint8Array)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", this.content);

              case 5:
                if (!ArrayBuffer.isView(this.content)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", new Uint8Array(this.content.buffer, this.content.byteOffset, this.content.byteLength));

              case 9:
                if (!(typeof Blob !== 'undefined' && this.content instanceof Blob)) {
                  _context.next = 17;
                  break;
                }

                reader = new FileReader();
                readPromise = new Promise(function (resolve, reject) {
                  reader.onerror = function (err) {
                    reject(err);
                  };

                  reader.onload = function () {
                    var arrayBuffer = reader.result;
                    resolve(new Uint8Array(arrayBuffer));
                  };

                  reader.readAsArrayBuffer(_this.content);
                });
                _context.next = 14;
                return readPromise;

              case 14:
                return _context.abrupt("return", _context.sent);

              case 17:
                typeName = Object.prototype.toString.call(this.content);
                throw new Error("Unexpected type ".concat(typeName));

              case 19:
                _context.next = 27;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);
                loadContentError = new Error("Error loading content: ".concat(_context.t0));
                console.error(loadContentError);
                throw loadContentError;

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 21]]);
      }));

      function loadContent() {
        return _loadContent.apply(this, arguments);
      }

      return loadContent;
    }()
  }, {
    key: "load",
    value: function load() {
      if (this.loadedData === undefined) {
        this.loadedData = this.loadContent();
      }

      return this.loadedData;
    }
  }], [{
    key: "normalizeContentDataType",
    value: function normalizeContentDataType(content, contentType) {
      try {
        if (typeof content === 'string') {
          var charset = (contentType || '').toLowerCase().replace('-', '');

          if (charset.includes('charset') && !charset.includes('charset=utf8') && !charset.includes('charset=ascii')) {
            throw new Error("Unable to determine byte length with charset: ".concat(contentType));
          }

          if (typeof TextEncoder !== 'undefined') {
            var encodedString = new TextEncoder().encode(content);
            return new Uint8Array(encodedString.buffer);
          }

          return utf8ToBytes(content);
        } else if (content instanceof Uint8Array) {
          return content;
        } else if (ArrayBuffer.isView(content)) {
          return new Uint8Array(content.buffer.slice(content.byteOffset, content.byteOffset + content.byteLength));
        } else if (typeof Blob !== 'undefined' && content instanceof Blob) {
          return content;
        } else if (typeof ArrayBuffer !== 'undefined' && content instanceof ArrayBuffer) {
          return new Uint8Array(content);
        } else if (Array.isArray(content)) {
          if (content.length > 0 && (!Number.isInteger(content[0]) || content[0] < 0 || content[0] > 255)) {
            throw new Error("Unexpected array values provided as file data: value \"".concat(content[0], "\" at index 0 is not an octet number. ").concat(this.supportedTypesMsg));
          }

          return new Uint8Array(content);
        } else {
          var typeName = Object.prototype.toString.call(content);
          throw new Error("Unexpected type provided as file data: ".concat(typeName, ". ").concat(this.supportedTypesMsg));
        }
      } catch (error) {
        console.error(error);
        throw new Error("Error processing data: ".concat(error));
      }
    }
  }]);

  return FileContentLoader;
}();
FileContentLoader.supportedTypesMsg = 'Supported types are: `string` (to be UTF8 encoded), ' + '`Blob`, `File`, `ArrayBuffer`, `UInt8Array` or any other typed array buffer. ';